export default "__VITE_ASSET__BH_eaOdX__"